import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../../utils/request';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import MultiSelect from './multiSelect';

const FilterByAssignee = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByAssignee }
  } = localizedStrings;
  const [assigneesList, setAssigneesList] = useState();

  useEffect(() => {
    const getAssignees = async () => {
      const result = await request.get('/sovAgentAndAdminUsers');
      if (result) {
        const transformedResult = _.get(result, 'data', []).map(item => ({
          label: item.name,
          value: item.id
        }));
        setAssigneesList(transformedResult);
      }
    };
    getAssignees();
  }, []);

  return (
    <div>
      <MultiSelect
        label={filterByAssignee}
        options={assigneesList}
        value={filters.assignedUserId}
        updateFilters={value => {
          setFilters({ ...filters, assignedUserId: value });
        }}
      />
    </div>
  );
};

FilterByAssignee.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByAssignee;
